<template>
    <div>
         <datatable :aanmeldingen='aanmeldingen'></datatable>
    </div>
</template>
<script>
import datatable from '@/components/beheer/Datatable.vue'

export default {
  name: 'historiebak',
  components: {
    datatable
  },
  mounted () {
    this.$store.dispatch('vergaarbak/getAanmeldingen', 3)
  },
  computed: {
    aanmeldingen: function () {
      return this.$store.state.vergaarbak.aanmeldingen
    }
  }
}
</script>
